const typography = {
  fontFamily: ['Satoshi', 'value-serif-regular'].join(','),
  h1: {
    fontSize: 42,
    fontWeight: 600,
    letterSpacing: -0.5
  },
  h2: {
    fontSize: 32,
    fontWeight: 600,
    letterSpacing: -0.5
  },
  h3: {
    fontSize: 28,
    fontWeight: 600,
    letterSpacing: -0.5
  },
  h4: {
    fontSize: 24,
    fontWeight: 400,
    letterSpacing: -0.5
  },
  h5: {
    fontSize: 20,
    fontWeight: 400,
    letterSpacing: -0.5
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: -0.5
  },
  subtitle2: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 2
  },
  body1: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.15
  },
  body2: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.15
  },
  buttonLarge: {
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: 0.46
  },
  buttonMedium: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.4
  },
  buttonSmall: {
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 0.46
  },
  inputText: {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0.15
  },
  inputLabel: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.15
  },
  helperText: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.4
  },
  overline: {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 1,
    textTransform: 'none'
  }
};

export { typography };
